export type ColorScale = {
  50: string;
  100: string;
  200: string;
  300: string;
  400: string;
  500: string;
  600: string;
  700: string;
  800: string;
  900: string;
};

function hexToRgb(hex: string): [number, number, number] {
  const h = hex.replace('#', '');
  const full = h.length === 3 ? h.replace(/./g, '$&$&') : h;
  return [
    parseInt(full.slice(0, 2), 16),
    parseInt(full.slice(2, 4), 16),
    parseInt(full.slice(4, 6), 16),
  ];
}

function rgbToHex(r: number, g: number, b: number): string {
  const clamp = (v: number) => Math.max(0, Math.min(255, Math.round(v)));
  return `#${[r, g, b].map((c) => clamp(c).toString(16).padStart(2, '0')).join('')}`;
}

function tint(rgb: [number, number, number], amount: number): string {
  return rgbToHex(
    rgb[0] + (255 - rgb[0]) * amount,
    rgb[1] + (255 - rgb[1]) * amount,
    rgb[2] + (255 - rgb[2]) * amount
  );
}

function shade(rgb: [number, number, number], amount: number): string {
  return rgbToHex(
    rgb[0] * (1 - amount),
    rgb[1] * (1 - amount),
    rgb[2] * (1 - amount)
  );
}

export function generateColorScale(hex: string): ColorScale {
  const rgb = hexToRgb(hex);

  return {
    50: tint(rgb, 0.9),
    100: tint(rgb, 0.8),
    200: tint(rgb, 0.6),
    300: tint(rgb, 0.4),
    400: tint(rgb, 0.2),
    500: rgbToHex(...rgb),
    600: shade(rgb, 0.15),
    700: shade(rgb, 0.3),
    800: shade(rgb, 0.5),
    900: shade(rgb, 0.7),
  };
}
